export default "__VITE_ASSET__1O5mqQ3Z__"